import { render, staticRenderFns } from "./NbCardBox.vue?vue&type=template&id=79540f9a&scoped=true&"
import script from "./NbCardBox.vue?vue&type=script&lang=js&"
export * from "./NbCardBox.vue?vue&type=script&lang=js&"
import style0 from "./NbCardBox.vue?vue&type=style&index=0&id=79540f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79540f9a",
  null
  
)

export default component.exports